var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-entity-icon",class:[
    { 'w-entity-icon-background': !!_vm.backgroundClass },
    { 'w-entity-icon--invalid': _vm.isIconInvalid },
    _vm.backgroundClass ],style:({
    width: (_vm.size + "px"),
    height: (_vm.size + "px"),
  })},[(_vm.resolvedItemType === 'reaction' && _vm.reactionType)?_c('img',{attrs:{"loading":"lazy","src":("/tko/public/images/reactions/" + _vm.reactionType + ".png")}}):_c(_vm.component,{tag:"Component",style:(_vm.svgStyles),attrs:{"id":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }